<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_3_' + this.id]">
    <div class="row">
      <div class="col-md-4">
        <div class="daria">
          <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="" />
        </div>
        <div class="erwin">
          <img src="https://cdn.exploreve.fr/content/personnages/erwin.svg" alt="" />
        </div>
      </div>
      <div class="col-md-4 text">
        <div class="left">
          <div class="arrowleft"></div>
          <p>Ça vous dirait d’aller explorer cette cabane dans l’arbre maintenant ? Ça a l’air lugubre !</p>
        </div>
        <div class="right">
          <p>
            Je suis partant, mais pas maintenant… ça fait déjà un moment qu’on est dans la Troposphère, et
            rappelez-vous, il ne faut pas y rester trop longtemps, au risque de perdre le contact avec la réalité.
          </p>
          <div class="arrowright"></div>
        </div>
        <div class="left">
          <div class="arrowleft"></div>
          <p>Okay, alors ce sera pour la fois prochaine ! Le code ce sera : <em>Cumulonimbus</em>. Note-le bien !</p>
        </div>
        <NextButton class="button" url="/immersion04/1" text="Accéder à la l'immersion 4" @click="resetTracker" />
      </div>
      <div class="col-md-4">
        <div class="leon">
          <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NextButton from "@/components/NextButton.vue";
import Tracker from "@/services/ProgressTracker";

export default {
  name: "IM_3_4",
  data: function () {
    return {
      id: 4
    };
  },
  components: {
    NextButton
  },
  methods: {
    resetTracker() {
      Tracker.resetTrackerImmersion();
    }
  },
  mounted() {
    this.$emit("audio", { action: "play", id: "music05" });
  }
};
</script>

<style scoped lang="scss">
.IM_3_4 {
  height: calc(100vh - 60px);
  background-image: url(https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/fond_conclusion_v1.svg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.leon {
  position: absolute;
  top: 15vh;
  left: 30%;
  img {
    height: 60vh;
  }
  z-index: 5;
}
.daria {
  position: absolute;
  top: 25vh;
  left: 35%;
  img {
    height: 40vh;
  }
}
.erwin {
  position: absolute;
  top: 25vh;
  left: 25%;
  img {
    height: 50vh;
  }
}
.row {
  height: 90vh;
  width: 100vw;
}
.text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.left,
.right {
  font-family: "Faune";
  display: table;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  margin: 20px;
  max-width: 80%;
  z-index: 5;
}

.left {
  padding-left: 0px;
  margin-left: 20px;
  margin-right: auto;
}

.right {
  padding-right: 0px;
  margin-right: 10px;
  margin-left: auto;
}

p {
  display: table-cell;
  vertical-align: middle;
}

.arrowleft {
  position: relative;
  content: "";
  left: -20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 20px solid white;
  z-index: 5;
}

.arrowright {
  position: relative;
  content: "";
  left: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 20px solid white;
}

.button {
  margin-top: 40px;
}
</style>
